__turbopack_context__.v({
  "className": "urbanist_90e94c2b-module__P-O9-G__className",
});
